import {
    ROOMS_OPERATING_REPORT_GET_START,
    ROOMS_OPERATING_REPORT_GET_SUCCESS,
    ROOMS_OPERATING_REPORT_GET_ERROR,
    RoomsOperatingReportAction
} from 'actions/insights/bookings/roomsOperatingReport/RoomsOperatingReportActionsTypes';

import {
    emptyRoomsOperatingReport,
    RoomsOperatingReportState,
    RoomsOperatingReportStatus
} from './RoomsOperatingReportState';

const initialState: RoomsOperatingReportState = {
    report: emptyRoomsOperatingReport,
    status: RoomsOperatingReportStatus.Initial,
    loading: false
};

export const RoomsOperatingReportReducer = (
    state = initialState,
    action: RoomsOperatingReportAction
): RoomsOperatingReportState => {
    switch (action.type) {
        case ROOMS_OPERATING_REPORT_GET_START:
            return { ...state, loading: true, status: RoomsOperatingReportStatus.Getting };

        case ROOMS_OPERATING_REPORT_GET_SUCCESS:
            return {
                ...state,
                loading: false,
                status: RoomsOperatingReportStatus.GettingSuccess,
                report: action.payload.report
            };

        case ROOMS_OPERATING_REPORT_GET_ERROR:
            return { ...state, loading: false, status: RoomsOperatingReportStatus.Error };

        default:
            return state;
    }
};

export default RoomsOperatingReportReducer;
